/* eslint-disable consistent-return */
/* add later */
// import heic2any from 'heic2any';
const toImage = (file) => new Promise((resolve, reject) => {
    if (!file) {
        return reject(new Error('file is required'));
    }
    if (/\.heic$/.test(file.name)) {
        return Promise.resolve('');
        // heic2any({ blob: file }).then((conversionResult) => {
        //   const url = URL.createObjectURL(conversionResult);
        //   const img = new window.Image();
        //   img.src = url;
        //   img.onload = () => {
        //     resolve({
        //       height: img.height,
        //       width: img.width,
        //       name: file.name,
        //       size: file.size,
        //       dataUrl: url,
        //       file,
        //     });
        //   };
        // });
    }
    const reader = new window.FileReader();
    reader.onabort = () => reject(new Error('file reading was aborted'));
    reader.onerror = () => reject(new Error('file reading has failed'));
    reader.onload = () => {
        const img = new window.Image();
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | ArrayBuffer | null' is not assignab... Remove this comment to see the full error message
        img.src = reader.result;
        img.onload = () => {
            resolve({
                height: img.height,
                width: img.width,
                name: file.name,
                size: file.size,
                dataUrl: reader.result,
                file,
            });
        };
    };
    reader.readAsDataURL(file);
});
export default toImage;
